// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M20 6.5L4 6.5M18 3L6 3M22 10V21L2 21L2 10L22 10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"collection"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 10L22 21L2 21L2 10L22 10Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 6.5L4 6.5M18 3L6 3M22 10V21L2 21L2 10L22 10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CollectionIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'collection',
    ref,
    icon: element,
  },
));

CollectionIcon.displayName = 'CollectionIcon';

export default CollectionIcon;
